const translations = {
  LOGIN_NTLM_BUTTON: {
    description:
      'This is a button to log into our system via NTLM. this text is the text for the this button',
    primaryValue: 'Log in with your Nike Account',
    stringKey: 'LOGIN_NTLM_BUTTON',
  },
  LOGIN_ATHLETE_BUTTON: {
    description:
      'Text for Login button for Athlete users that need to use that form of authentication',
    primaryValue: 'Athlete username & password',
    stringKey: 'LOGIN_ATHLETE_BUTTON',
  },
  LOG_INTO_PASS_PLAY: {
    description: 'Header text for the login page',
    primaryValue: 'Log into Pass Play',
    stringKey: 'LOG_INTO_PASS_PLAY',
  },
  LOGIN_MAIN_TEXT: {
    description: 'Main text for the login page that describes the two different ways to log in',
    primaryValue:
      'Pass Play allows you to log in with either your Nike login (NT) credentials or Athlete username and password',
    stringKey: 'LOGIN_MAIN_TEXT',
  },
};

export default translations;
